import { observer } from 'mobx-react'
import type { Instance } from 'mobx-state-tree'
import styled from 'styled-components'
import type { FilterModel } from 'models/common/Filters/FilterModel'
import { vehiclesPageWithCreateNewVehicleLink } from 'router'
import { PrimaryButton } from '../Button/Button'
import { SvgIcons } from '../Icon/Icon'
import { PageTitle } from '../Page/Page'
import { Column, Row, TableTitle, TableTitleRow } from '../Table/Table'
import TableFilters from '../TableFilters/TableFilters'

const SearchAndAddRow = styled(Row)`
    justify-content: space-between;
    align-items: center;
    margin-block-end: 1.5em;
`

const SearchContainer = styled.div`
    flex: 1;
    max-inline-size: 20em;
`

interface VehicleTableHeaderProps {
    // Number of vehicles shown in the table, after the search
    shownVehicleCount: number
    filters: Instance<typeof FilterModel>
}

// The vehicles page title, the vehicle count, the search box and the add vehicle button
export const VehicleTableHeader = observer(({ shownVehicleCount, filters }: VehicleTableHeaderProps) =>
    <>
        <TableTitleRow>
            <Column>
                <PageTitle style={{ marginBlockEnd: '0.25em' }}>Vehicles</PageTitle>
                <TableTitle {...{ entityCount: shownVehicleCount, entityName: 'vehicle' }} />
            </Column>
        </TableTitleRow>
        <SearchAndAddRow>
            <SearchContainer>
                <TableFilters {...{ filters }} />
            </SearchContainer>
            <PrimaryButton {...{
                text: 'Add new vehicle',
                startComponent: <SvgIcons.PlusSvg />,
                ...vehiclesPageWithCreateNewVehicleLink,
            }}/>
        </SearchAndAddRow>
    </>
)
